if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right.next');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left.previous');
      this.isLooping = this.dataset.isLooping === 'true' ? true : false;
      this.interval = this.dataset.interval * 1000;
      this.index = 0;
      this.length = this.content.length;

      
      
      this.content[this.index].classList.add('active');
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }
      
      this.autoSlideInterval = null;

      if(this.isLooping) {
        this.startAutoSlide('start');
      }
      
    }

    killAutoSlide() {
      this.startAutoSlide('kill');
      if(this.nextButton) this.nextButton.remove();
      if(this.prevButton) this.prevButton.remove();
    }


    startAutoSlide(action = 'start') {
      
      if (action == 'start') {
        
        this.addEventListener('mouseenter', this.pauseAutoSlide);
        this.addEventListener('mouseleave', this.resumeAutoSlide);
        this.addEventListener('touchstart', this.pauseAutoSlide);
        this.addEventListener('touchend', this.resumeAutoSlide);
        
        this.autoSlideInterval = setInterval(() => {
          this.changeSlide('next');
        }, this.interval);
        
      } else {
        if (this.autoSlideInterval) {
          clearInterval(this.autoSlideInterval);
          this.autoSlideInterval = null;
        }
      }
    }

    pauseAutoSlide() {
      if (this.isLooping) {
        this.startAutoSlide('pause');
      }
    }

    resumeAutoSlide() {
      if (this.isLooping) {
        this.startAutoSlide('start');
      }
    }

    changeSlide(direction) {

      if (this.nextButton) this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      if (this.prevButton) this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.content[this.index].classList.remove('no-transition');
        this.content[this.index].classList.remove('active');
        this.index = (this.index + 1) % this.length;
        this.content[this.index].classList.add('active');
      } else if ( direction == 'prev' ) {
        this.content[this.index].classList.remove('no-transition');
        this.content[this.index].classList.remove('active');
        this.index = (this.index - 1 + this.length) % this.length;
        this.content[this.index].classList.add('active');
      }
      
      if(this.isLooping === false) {
        if ( this.index == this.length - 1 ) {
          this.nextButton.classList.add('announcement-bar__content-nav--disabled')
        } else if ( this.index == 0 ) {
          this.prevButton.classList.add('announcement-bar__content-nav--disabled')
        }
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'instant'
      });

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}